var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, EventEmitter, OnInit, } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatMenu, MatMenuTrigger } from '@angular/material';
import { CreateTripCommand, TripStorageCommand } from '../../../../commands/visitor/create.trip.command';
import { MatFieldComponent } from '../../../../common/components';
import { ImageService } from '../../../../services/image.service';
import { LocalStorageService } from '../../../../services/localStorageService';
import { guid } from '../../../../utils/guid';
import { VisitorApiService } from '../../../../services/visitor.api.service';
import { SocialLoginPopupComponent } from '../../../../common/components/social.login.popup/social.login.popup.component';
import { clone } from '../../../../common/extensions';
import { VisitorTripNotifyAddOrRemoveItemStore } from '../../../../stores/visitor.calendar.store';
import { config } from '../../../../../config/config';
import { BaseComponent } from '../../../../common/components/base.component';
import { ActivatedRoute } from '@angular/router';
var VisitorTripAddToTripMenuComponent = /** @class */ (function (_super) {
    __extends(VisitorTripAddToTripMenuComponent, _super);
    function VisitorTripAddToTripMenuComponent(visitorApiService, formBuilder, notifyAddOrRemoveItemStore, activatedRoute, imageService) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.visitorApiService = visitorApiService;
        _this.formBuilder = formBuilder;
        _this.notifyAddOrRemoveItemStore = notifyAddOrRemoveItemStore;
        _this.activatedRoute = activatedRoute;
        _this.imageService = imageService;
        _this.isShow = true;
        _this.isUserloggedIn = false;
        _this.inTripText = 'in my trip';
        _this.addToTripText = 'add to my trip';
        _this.bgColor = '#5cbcff';
        // @Input() public trips = [];
        // @Input() public menuTrigger: any;
        _this.type = 'event';
        _this.trips = [];
        _this.isAddingSuccess = [];
        _this.inTripStatus = [];
        _this.isAddingNewTrip = false;
        _this.isInAnyTrip = false;
        _this.newTripTitle = '';
        _this.onAddToTrip = new EventEmitter();
        _this.onRemoveFromTrip = new EventEmitter();
        _this.onAddNewTrip = new EventEmitter();
        _this.onAddFirstTrip = new EventEmitter();
        return _this;
    }
    VisitorTripAddToTripMenuComponent.prototype.ngOnInit = function () {
        var _this = this;
        // let {hubName, tripId} = this.allRouteParams;
        // this.hubName = hubName;
        this.type = this.getItemType();
        this.trips = this.loadTripsInLocalStorage();
        this.getInTripStatus(this.trips);
        this.checkIsInAnyTrip();
        this.tripFormGroup = this.formBuilder.group({
            tripTitle: [null, [Validators.required]],
        });
        this.notifyAddOrRemoveItemStore.notifyCommand.takeUntil(this.isDestroyed).subscribe(function (item) {
            _this.checkIsInAnyTrip();
        });
    };
    VisitorTripAddToTripMenuComponent.prototype.getInTripStatus = function (trips) {
        var _this = this;
        this.inTripStatus = [];
        if (!trips) {
            trips = this.loadTripsInLocalStorage();
        }
        if (!trips || !trips.length) {
            return null;
        }
        trips.forEach(function (trip) {
            var isInTrip = trip.attractions.any(function (x) { return x.item.id === _this.item.id; });
            _this.inTripStatus.push(isInTrip);
        });
    };
    VisitorTripAddToTripMenuComponent.prototype.exitAddingNewTrip = function ($event) {
        $event && $event.stopPropagation();
        this.isAddingNewTrip = false;
    };
    VisitorTripAddToTripMenuComponent.prototype.saveNewTrip = function () {
        //this.onAddNewTrip.emit({title: this.newTripTitle, item: this.item, type: this.type});
        this.createNewTrip(this.newTripTitle, this.item, this.type);
        this.menuTrigger.closeMenu();
        this.newTripTitle = '';
        this.isAddingNewTrip = false;
    };
    VisitorTripAddToTripMenuComponent.prototype.newTripFieldFocus = function ($event) {
        $event.stopPropagation();
    };
    VisitorTripAddToTripMenuComponent.prototype.addOrRemoveFromTrip = function ($event, tripIndex) {
        $event.stopPropagation();
        if (this.inTripStatus[tripIndex]) {
            this.removeFromTrip(this.item._id, tripIndex);
        }
        else {
            this.addItemToTrip(this.item, this.type, this.item._id, tripIndex);
        }
        this.showAddingToTripSuccess(tripIndex);
        this.checkIsInAnyTrip();
        this.notifyAddOrRemoveItemStore.notifyCommand.next(null);
    };
    VisitorTripAddToTripMenuComponent.prototype.addItemToTrip = function (item, type, feedId, tripIndex) {
        if (SocialLoginPopupComponent.isUserLoggedIn) {
            this.visitorApiService
                .addAtractionToTrip(this.hubName, {
                feedType: type,
                feedId: feedId,
                userFacebookId: SocialLoginPopupComponent.userId,
                tripIndex: tripIndex,
            })
                .subscribe();
        }
        this.addToLocalStorage(item, tripIndex);
    };
    VisitorTripAddToTripMenuComponent.prototype.removeFromTrip = function (id, tripIndex) {
        if (id) {
            if (SocialLoginPopupComponent.isUserLoggedIn) {
                this.removeTripItemFromDB(id, tripIndex);
            }
            this.removeFromLocalStorage(id, tripIndex);
        }
    };
    VisitorTripAddToTripMenuComponent.prototype.removeFromLocalStorage = function (id, tripIndex) {
        var key = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName);
        var keyWithUserID = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName, SocialLoginPopupComponent.userId);
        var trip = JSON.parse(localStorage.getItem(key));
        if (!trip || !trip.trips || trip.trips.length <= tripIndex) {
            return;
        }
        if (trip.trips[tripIndex] && trip.trips[tripIndex].attractions.length) {
            var index = trip.trips[tripIndex].attractions.getElementIndex(function (x) { return x.feedId === id; });
            trip.trips[tripIndex].attractions.splice(index, 1);
        }
        trip.trips[tripIndex].attractions = trip.trips[tripIndex].attractions.removeDuplicate();
        trip.timestamp = new Date();
        localStorage.setItem(key, JSON.stringify(trip));
        localStorage.setItem(keyWithUserID, JSON.stringify(trip));
        this.trips = trip.trips;
    };
    VisitorTripAddToTripMenuComponent.prototype.removeTripItemFromDB = function (id, tripIndex) {
        this.visitorApiService
            .removeAtractionFromTrip(this.hubName, {
            feedId: id,
            userFacebookId: SocialLoginPopupComponent.userId,
            tripIndex: tripIndex,
        })
            .subscribe();
    };
    VisitorTripAddToTripMenuComponent.prototype.showAddingToTripSuccess = function (index) {
        var _this = this;
        this.isAddingSuccess = [];
        this.trips.forEach(function (x) {
            _this.isAddingSuccess.push(false);
        });
        this.isAddingSuccess[index] = true;
        setTimeout(function () {
            _this.isAddingSuccess[index] = false;
            _this.menuTrigger.closeMenu();
        }, 1000);
        setTimeout(function () {
            _this.menuTrigger.closeMenu();
        }, 900);
    };
    VisitorTripAddToTripMenuComponent.prototype.addNewTrip = function () {
        var _this = this;
        this.isAddingNewTrip = true;
        setTimeout(function () {
            _this.tripTitle.focus();
        });
    };
    VisitorTripAddToTripMenuComponent.prototype.checkIsInAnyTrip = function () {
        var _this = this;
        this.trips = this.loadTripsInLocalStorage();
        if (!this.trips || !this.trips.length) {
            return false;
        }
        this.isInAnyTrip = false;
        this.trips.forEach(function (trip) {
            if (trip.attractions.any(function (x) { return x.item.id === _this.item.id; })) {
                _this.isInAnyTrip = true;
            }
        });
    };
    VisitorTripAddToTripMenuComponent.prototype.openTripMenu = function () {
        var _this = this;
        this.trips = this.loadTripsInLocalStorage();
        this.getInTripStatus();
        if (!this.trips || !this.trips.length) {
            this.onAddFirstTrip.emit({ item: this.item, type: this.type });
            return;
        }
        this.trips.forEach(function (x) {
            _this.isAddingSuccess.push(false);
        });
        this.menuTrigger.openMenu();
    };
    VisitorTripAddToTripMenuComponent.prototype.createNewTrip = function (title, addThisItem, type, callback) {
        var attractions = [];
        if (addThisItem) {
            attractions.push({ feedId: addThisItem._id, feedType: type, order: 1 });
        }
        if (SocialLoginPopupComponent.isUserLoggedIn) {
            this.visitorApiService
                .createTrip(this.hubName, {
                id: guid(),
                userFacebookId: SocialLoginPopupComponent.userId,
                description: '',
                hubName: this.hubName,
                newTrip: { id: guid(), title: title || this.newTripTitle, img: null, attractions: attractions },
                trips: [],
            })
                .subscribe(function () { });
        }
        this.trips = this.addNewTripToLocalStorage(title || this.newTripTitle, addThisItem, type).trips;
        this.checkIsInAnyTrip();
        this.notifyAddOrRemoveItemStore.notifyCommand.next(null);
        if (callback) {
            callback();
        }
    };
    VisitorTripAddToTripMenuComponent.prototype.addNewTripToLocalStorage = function (title, item, type) {
        var key = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName);
        var keyWithUserID = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName, SocialLoginPopupComponent.userId);
        var trips = JSON.parse(localStorage.getItem(key));
        var newTrip = new CreateTripCommand();
        if (!trips || !trips.trips || !trips.trips.length) {
            trips = new TripStorageCommand();
        }
        else {
            if (trips.trips.length >= config.tripPlanner.maxTripCount) {
                return;
            }
        }
        newTrip.attractions = [];
        if (item) {
            newTrip.attractions.push({
                feedType: type,
                feedId: item._id,
                order: 1,
                item: item,
            });
        }
        newTrip.title = title;
        newTrip.timestamp = new Date();
        newTrip.hubName = this.hubName;
        newTrip.img = null;
        trips.trips.push(newTrip);
        var tripsWithUserId = clone(trips);
        localStorage.setItem(key, JSON.stringify(trips));
        tripsWithUserId.userFacebookId = SocialLoginPopupComponent.userId || null;
        localStorage.setItem(keyWithUserID, JSON.stringify(tripsWithUserId));
        return trips;
    };
    VisitorTripAddToTripMenuComponent.prototype.addToLocalStorage = function (item, tripIndex) {
        var key = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName);
        var keyWithUserID = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName, SocialLoginPopupComponent.userId);
        var trip = JSON.parse(localStorage.getItem(key));
        if (!trip || !trip.trips) {
            return;
        }
        if (tripIndex >= trip.trips.length) {
            return;
        }
        trip.trips[tripIndex].attractions = trip.trips[tripIndex].attractions.removeDuplicate();
        trip.trips[tripIndex].attractions.push({
            feedType: item.startTime ? 'event' : 'place',
            feedId: item._id,
            order: trip.trips[tripIndex].attractions.length,
            item: item,
        });
        trip.trips[tripIndex].attractions = trip.trips[tripIndex].attractions.removeDuplicate();
        trip.trips[tripIndex].timestamp = new Date();
        trip.trips[tripIndex].updateTime = new Date();
        trip.updateTime = new Date();
        trip.trips[tripIndex].hubName = this.hubName;
        localStorage.setItem(key, JSON.stringify(trip));
        trip.userFacebookId = SocialLoginPopupComponent.userId || null;
        localStorage.setItem(keyWithUserID, JSON.stringify(trip));
    };
    VisitorTripAddToTripMenuComponent.prototype.loadTripsInLocalStorage = function () {
        var key = LocalStorageService.getLocalStorageKeyForVisitorTrip(this.hubName);
        var trips = JSON.parse(localStorage.getItem(key));
        if (!trips || !trips.trips || !trips.trips.length) {
            trips = new TripStorageCommand();
        }
        return trips.trips;
    };
    VisitorTripAddToTripMenuComponent.prototype.getItemType = function () {
        return this.item.startTime ? 'event' : 'place';
    };
    return VisitorTripAddToTripMenuComponent;
}(BaseComponent));
export { VisitorTripAddToTripMenuComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/trip/add.to.trip.menu/visitor.trip.add.to.trip.menu.component.ts.pre-build-optimizer.js